import React from 'react';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { EPage, ReactFCV } from '@types';

import { ICheckoutPageLayoutMessages } from '../../../model';
import { OrderPageLayout } from '../../layouts';
import { LoadableRoute } from '../../LoadableRoute';
import { RouteHelmet } from '../../RouteHelmet';

interface IOrderRouteProps {
  page: EPage;
  skeletonComponent: React.FunctionComponent;
  component: React.FunctionComponent;
  messages: ICheckoutPageLayoutMessages;
}

export const OrderRoute: ReactFCV<IOrderRouteProps> = ({ page, skeletonComponent, component, messages }) => {
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  const {
    applicationSettings: {
      callCenter: { number, isOpened, openingHours },
    },
  } = useApplicationRuntimeContext();

  return (
    <>
      <RouteHelmet page={page} />
      <OrderPageLayout
        page={page}
        skeletonComponent={skeletonComponent}
        messages={messages}
        callCenterOpeningHours={openingHours}
        isCallCenterOpened={isOpened}
        callCenterPhoneNumber={number}
        homePageUrlAddress={websiteHostAddress}>
        <LoadableRoute component={component} skeletonComponent={skeletonComponent} />
      </OrderPageLayout>
    </>
  );
};
